export default "__VITE_ASSET__xrMB6Wzk__"